import * as types from "./enumActionTypes";
import enumApi from "./enumApi";

let currentRequests = [];

export function clearEnums() {
  return { type: types.CLEAR_ENUMS };
}

export function getEnum(name, query, state) {
  if (!!state[name] && !!state[name].loaded && state[name].query == query) {
    return { type: types.GET_ENUM_EXISTING };
  }
  if (currentRequests.includes(name)) {
    return { type: types.GET_ENUM_FETCHING };
  }
  currentRequests.push(name);
  return {
    type: types.GET_ENUM,
    promise: enumApi.getEnum(name, query).then((res) => {
      const i = currentRequests.indexOf(name);
      if (i != -1) {
        currentRequests.splice(i, 1);
      }
      return res;
    }),
    payload: { name },
    query,
  };
}



// WEBPACK FOOTER //
// ./src/utils/enums/enumActions.js